const CuriosoConfigOptions = {
  character: {
    scaly: 'Catlizard',
    furry: 'Moosebear',
    feathery: 'Birdrabbit',
  },
  skin: ['Furry', 'Scaly', 'Feathery'],
  nature: ['Playing', 'Lost', 'Exploring'],
  mood: ['Brave', 'Friendly', 'Silly'],
  defaultAugmentationType: 'head',
};

export const defaultCurioso = {
  skin: CuriosoConfigOptions.skin[0].toLocaleLowerCase(),
  mood: CuriosoConfigOptions.mood[0].toLocaleLowerCase(),
  nature: CuriosoConfigOptions.nature[0].toLocaleLowerCase(),
};

export const defaultSeason3Curioso = {
  type: 'bird',
  skin: 'feathery',
};

export default CuriosoConfigOptions;
